var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c('div',[_c('router-view')],1):_vm._e(),(_vm.loading)?_c('div',{staticClass:"splash active"},[_c('div',{staticClass:"splash-icon"},[_c('logo',{staticClass:"logo",attrs:{"type":"light"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }